angular.module('autoremind.dashboard.directives')
    .directive('resellerInTrial', ['$parse', 'dashboardService', '$interval', 'resellerService', '$rootScope', function ($parse, dashboardService, $interval, resellerService, $rootScope) {
        return {
            restrict: 'EA',
            scope: true,
            templateUrl: 'app/dashboard/widgets/reseller-in-trial/reseller-in-trial.html',
            link: function (scope, elem, attr) {
                scope.params = $parse(attr.params)(scope);
                scope.viewModel = {
                    stats: {
                        trialCust: null
                    },
                    updateInterval: angular.isDefined(scope.params.settings) && angular.isDefined(scope.params.settings.updateInterval) ? scope.params.settings.updateInterval : false,
                    isBusy: false
                };
                scope.getStats = function () {
                    if (scope.viewModel.isBusy) {
                        return;
                    }
                    scope.viewModel.isBusy = true;
                    resellerService.getStats()
                        .then(function (data) {
                        scope.viewModel.isBusy = false;
                        scope.viewModel.stats.trialCust = resellerService.viewModel.stats.trialCust;
                    }, function () {
                        scope.viewModel.isBusy = false;
                    });
                };
                scope.getStats();
                scope.stopHandler = null;
                /* We should not keep updating due to limited number of requests to the ZOHO API, so user must refresh
                 if (scope.viewModel.updateInterval) {
                 scope.stopHandler = $interval(function () {
                 scope.getStats();
                 }, Math.abs(scope.viewModel.updateInterval) )
                 }
                 */
                scope.$on("$locationChangeStart", function (event, next, current) {
                    if (scope.stopHandler) {
                        $interval.cancel(scope.stopHandler);
                    }
                });
                $rootScope.$on('event:auth-logout', function () {
                    if (scope.stopHandler) {
                        $interval.cancel(scope.stopHandler);
                    }
                });
            }
        };
    }]);
//# sourceMappingURL=reseller-in-trial.js.map